import React from "react";
import { Box, Text, Button, Link, Image, IconButton, Avatar } from "gestalt";
import {
  createPinterestShare,
  createEmailShare,
  createFacebookShare
} from "./social";
import ReactGA from "react-ga";
const ga = props => {
  ReactGA.event({
    category: "Product",
    action: "Product Clicked",
    label: `${props.name}`
  });
};
const gaEmail = props => {
  ReactGA.event({
    category: "Social",
    action: "Email Share Clicked",
    label: `${props.name}`
  });
};
const gaPinterest = props => {
  ReactGA.event({
    category: "Social",
    action: "Pinterest Share Clicked",
    label: `${props.name}`
  });
};
const gaFacebook = props => {
  ReactGA.event({
    category: "Social",
    action: "Facebook Share Clicked",
    label: `${props.name}`
  });
};
function Product(props) {
  return (
    <Box padding={2} shape="rounded">
      <Link href={props.url} target="blank" onClick={() => ga(props)}>
        <Box color="white" width="100%" height="318px">
          <Image
            naturalHeight={1}
            naturalWidth={1}
            fit="contain"
            alt={props.name}
            src={props.imageUrl}
          />
        </Box>
      </Link>
      <Box
        alignItems="center"
        justifyContent="between"
        direction="row"
        display="flex"
        padding={4}
      >
        <Text bold size="xl">
          <Link href={props.url} target="blank" onClick={() => ga(props)}>
            {props.name}
          </Link>
        </Text>
      </Box>
      <Box paddingX={4}>
        <Text>${props.price}</Text>
      </Box>
      <Box marginBottom={4} padding={4}>
        <div className="product-caption">{props.description}</div>
        {/* <Box
          alignItems="center"
          direction="row"
          display="flex"
          marginTop={4}
          marginStart={-1}
          marginEnd={-1}
        >
          <Box paddingX={1}>
            <Avatar
              size="md"
              src="../assets/images/danau.jpg"
              name="Dan"
              verified
            />
          </Box>
          <Box paddingX={1}>
            <Text bold>Dan Au</Text>
            <Text>Shop My Mom</Text>
          </Box>
        </Box> */}
      </Box>
      <Box shape="rounded">
        <Box display="flex" direction="row" justifyContent="between">
          <Box display="flex" direction="row" column={6} paddingX={2}>
            <Button
              accessibilityLabel={`Buy ${props.name}`}
              color="gray"
              text="Buy"
              size="md"
              onClick={() => {
                ga(props);
                window.open(props.url, "_blank");
              }}
            />
          </Box>
          <Box display="flex">
            <Box paddingX={1}>
              <IconButton
                accessibilityLabel="Love"
                icon="gmail"
                iconColor="darkGray"
                size="sm"
                onClick={() => {
                  gaEmail(props);
                  window.open(
                    createEmailShare({
                      url: props.url,
                      title: props.name,
                      description: props.description
                    }),
                    "_blank"
                  );
                }}
              />
            </Box>
            <Box paddingX={1}>
              <IconButton
                accessibilityLabel="Love"
                icon="facebook"
                iconColor="darkGray"
                size="sm"
                onClick={() => {
                  gaFacebook(props);
                  window.open(
                    createFacebookShare({
                      url: props.url,
                      title: props.name
                    }),
                    "_blank"
                  );
                }}
              />
            </Box>
            <Box paddingX={1}>
              <IconButton
                accessibilityLabel="Love"
                icon="pinterest"
                iconColor="darkGray"
                size="sm"
                onClick={() => {
                  gaPinterest(props);
                  window.open(
                    createPinterestShare({
                      url: props.url,
                      title: props.name,
                      media: props.imageUrl ? props.imageUrl : "",
                      description: props.description
                    }),
                    "_blank"
                  );
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Product;



// WEBPACK FOOTER //
// ./src/Components/product.js